<template>
    <div class="faq-collapsible">
        <button
            :id="id"
            type="button"
            :class="{'faq-collapsible__header': true, 'faq-collapsible__header--open': isOpen}"
            :aria-expanded="isOpen"
            @click="toggleCollapsible"
        >
            <slot name="header"></slot>
            <VJoyIcon name="chevron-down" class="faq-collapsible__chevron" color="neutral-50" />
        </button>
        <div
            ref="contentRef"
            role="region"
            :class="{'faq-collapsible__content': true, 'faq-collapsible__content--open': isOpen}"
            :aria-labelledby="id"
        >
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {Ref} from 'vue';
    import {ref} from 'vue';
    import {VJoyIcon} from '@maltjoy/core-vue';

    type FaqCollapsibleProps = {
        id: string;
    };

    defineProps<FaqCollapsibleProps>();

    const isOpen = ref(false);
    const contentRef: Ref<HTMLDivElement | null> = ref(null);

    function toggleCollapsible() {
        isOpen.value = !isOpen.value;

        if (contentRef.value) {
            contentRef.value.style.maxHeight = isOpen.value ? `${contentRef.value.scrollHeight}px` : '0px';
        }
    }
</script>

<style lang="scss">
    .faq-collapsible {
        &__header {
            background-color: transparent;
            width: 100%;
            padding: 0;
            border: none;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .faq-collapsible__chevron {
                transition: transform var(--joy-transition-duration-default) var(--joy-transition-timing-function);
                transform: rotate(0deg);
            }

            &--open .faq-collapsible__chevron {
                transform: rotate(180deg);
            }
        }

        &__content {
            transition: max-height var(--joy-transition-duration-long) var(--joy-transition-timing-function);
            max-height: 0;
            overflow: hidden;
        }
    }
</style>
